import {Injectable} from '@angular/core';
import {MinizaemApiClientService} from "../../core/services/minizaem-api-client.service";
import {Observable} from "rxjs";
import {News} from "../models/news";
import {NewsListWrapper} from "../models/news-list-wrapper";

@Injectable({
  providedIn: 'root'
})
export class NewsService extends MinizaemApiClientService {
  getBySlugFromApi(slug: string): Observable<News> {
    return this.http.get<News>(this.buildURI(`api/news/show/${slug}`));
  }

  getListFromApi(page: number = 1): Observable<NewsListWrapper> {
    return this.http.get<NewsListWrapper>(this.buildURI(`api/news/show?page=${page}`));
  }
}
